import React from "react";
import "./Navbar.css";
import { FaMapMarkerAlt, FaPhone, FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { CiMail } from "react-icons/ci";
import { NavLink } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="text-white text-center text-lg-start bg-nss mt-4">
      <div className="container p-4">
        <div className="row mt-4">
          <div className="col-lg-4 col-md-6 mb-4 mb-md-0 text-center text-lg-left">
            <h5 className="text-uppercase mb-4">PICT NSS</h5>
            <img
              src="https://i.postimg.cc/pTSWjNzG/Screenshot-694.png"
              alt="NSS Logo"
              className="nss-logo img-fluid"
              style={{ borderRadius: "100px", maxWidth: "150px" }}
            />
          </div>

          <div className="col-lg-4 col-md-12 mb-4 mb-md-0 text-center text-lg-left">
            <h5 className="text-uppercase mb-4">NOT ME BUT YOU</h5>
            <p>
              Pune Institute Of Computer Technology has been participating in
              the NSS scheme since 2010. The NSS unit of PICT has 150+
              volunteers. The motto of NSS “Not Me But You” upholds the need
              for selfless service.
            </p>
            <div className="mt-4">
              <a href="https://www.facebook.com/pictnss/" style={{ textDecoration: 'none', color: 'white' }}>
                <FaFacebookF className="me-3" />
              </a>
              <a href="https://www.linkedin.com/company/pictnss/mycompany/" style={{ textDecoration: 'none', color: 'white' }}>
                <FaLinkedinIn className="me-3" />
              </a>
              <a href="https://www.instagram.com/pictnss/" style={{ textDecoration: 'none', color: 'white' }}>
                <FaInstagram />
              </a>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 mb-4 mb-md-0 text-center text-lg-left">
            <h5 className="text-uppercase mb-4">Contact us</h5>
            <p className="mb-3">
              <FaMapMarkerAlt />
              <span className="ms-2">
                Survey No. 27, Near Trimurti Chowk,
                Bharati Vidyapeeth Campus,
                Dhankawadi, Pune, Maharashtra, 411043.
              </span>
            </p>
            <p className="mb-3">
              <CiMail />
              <span className="ms-2">nss@pict.edu</span>
            </p>
            <p className="mb-3">
              <FaPhone />
              <span className="ms-2">+91 20 24371101</span>
            </p>
          </div>
        </div>
      </div>

      <div className="text-center p-3 bg-footer">
        <NavLink className="text-white" to="/developer">
          Developed by Web Team of PICT NSS
        </NavLink>
      </div>
    </footer>
  );
};

export default Footer;
